import { Injectable } from '@angular/core';
import { ReviewSetSdk } from '../sdks/review-set.sdk';
import { BehaviorSubject, Observable } from 'rxjs';
import { ReviewSet } from '../models/ui/review-set.model';
import { ExportSdk } from '../sdks/export.sdk';

@Injectable({
	providedIn: 'root'
})
export class DiscoveryManager {
	public reviewSets$: Observable<ReviewSet[]>;
	public report$: Observable<Record<string,string>[]>;

	private reviewSetCollectionSource: BehaviorSubject<ReviewSet[]> = new BehaviorSubject<ReviewSet[]>(null);
	private reportSource: BehaviorSubject<Record<string,string>[]> = new BehaviorSubject<Record<string,string>[]>(null);


	constructor(private reviewSetSdk: ReviewSetSdk, private exportSdk: ExportSdk) {
		this.reviewSets$ = this.reviewSetCollectionSource.asObservable();
		this.report$ = this.reportSource.asObservable();
	}

	public refreshReviewSetCollection(): void {
		this.reviewSetSdk.get().subscribe((response) => this.reviewSetCollectionSource.next(response));
	}

	public getNextDocument(params: GetNextDocumentParams): Observable<any> {
		return this.reviewSetSdk.nextDocument(params);
	}

	public exitReview(params: ExitReviewParams): Observable<any> {
		return this.reviewSetSdk.checkInReviewSet(params);
	}

	public addReviewSet(params: AddReviewSetParams): Observable<ReviewSet> {
		return this.reviewSetSdk.post({ reviewSet: params.set });
	}

	public saveReviewSet(params: AddReviewSetParams): Observable<void> {
		return this.reviewSetSdk.put({ reviewSet: params.set });
	}

	public startReviewSet(params: StartReviewSetParams): Observable<any> {
		return this.reviewSetSdk.startReviewSet({ reviewSetId: params.reviewSet.id });
	}

	public stopReviewSet(params: StopReviewSetParams): Observable<any> {
		return this.reviewSetSdk.stopReviewSet({ reviewSetId: params.reviewSet.id });
	}

	public deleteReviewSets(params: StopReviewSetParams): Observable<any> {
		return this.reviewSetSdk.delete({ reviewSet: params.reviewSet });
	}

	public refreshReviewTrackingReport(params: TrackingReportParams = null): void {
		this.reviewSetSdk.generateReportData(params).subscribe((r) => {
			this.reportSource.next(r);
		});
	}

	public exportReviewTrackingReport(params: TrackingReportParams = null): Observable<string> {
		return this.exportSdk.exportReviewTracking(params);
	}
}

interface GetNextDocumentParams {
	reviewSetId: string;
}

interface ExitReviewParams {
	reviewSetId: string;
}

interface AddReviewSetParams {
	set: ReviewSet;
}

interface StartReviewSetParams {
	reviewSet: ReviewSet;
}

interface StopReviewSetParams {
	reviewSet: ReviewSet;
}

interface TrackingReportParams {
	unit: number;
	dateUnit: number;
	filter: string;
}
